class Queue {
    constructor({maxPending = Infinity, maxQueue = Infinity}) {
        this.promise = window ? window.Promise : Promise;
        this.pending = 0;
        this.queue = [];
        this.maxPending = maxPending;
        this.maxQueue = maxQueue;
        this.state = 'start';
    }

    set promiseContext(promiseContext) {
        this.promise = promiseContext;
    }

    get pendingLength() {
        return this.pending;
    }

    get queueLength() {
        return this.queue.length;
    }

    get currentQueue() {
        return this.queue;
    }

    get remainQueueLength() {

        if(this.maxQueue == 0) return 0;
        else {
            let _len = this.maxQueue - this.queue.length - this.pending;
            return _len < 0 ? 0 : _len;
        }
    }

    add (promise) {

        // return new Promise((resolve, reject) => {

            if (this.queue.length >= this.maxQueue) {
                console.log('Queue limit');
                return;
            }

            this.queue.push(promise);

            this._runQueue();
        // })
    }

    play () {
        this.state = 'start';
        this._runQueue();
    }

    pause () {
        this.state = 'stop';
    }

    _runQueue () {
        if (this.pending >= this.maxPending) {
            return false;
        }

        if(this.state == 'stop') {
            return false;
        }

        let _pendingPromise = this.queue.shift();

        if (!_pendingPromise) {
            return false;
        }

        try {
            this.pending++;
            this.resolve(_pendingPromise())
                .then((value) => {
                    this.pending--;
                    this._runQueue();
                }, (err) => {
                    this.pending--;
                    this._runQueue();
                });
        } catch (err) {
            this.pending--;
            this._runQueue();
        }

        return true;
    }

    resolve (value) {
        return this.promise.resolve(value);
    };

}

export default Queue;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/queue.js